/* eslint-disable react-hooks/exhaustive-deps */
import React,{useMemo,useState,useEffect} from "react";
import moment from  'moment';
import {SectorRenderer} from "../../sales/inner-components/renderers";
import { formatDateByTimezone} from '../../../utils/commonFunctions';
let items=[];
const CountTable = (props) => {

  return (<>  {props.mode==='paxSummary'?showPaxSummary(props):showSectorCapacity(props)}</>
  )
}
const showPaxSummary=(px)=>{
  const{paxSum}=px;
return(<div className="flexCol">
  <table className="sub-table">
    <thead>
      <tr>
        <th>Economy</th>
        <th>Premium Economy</th>
        <th>Business Class</th>
        <th>First Class</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{backgroundColor:" #001d2b",color:'#ffff',width:'auto'}}>{paxSum?.ecy??""}</td>
        <td>{paxSum?.pc ??""}</td>
        <td>{paxSum?.bc ??""}</td>
        <td>{paxSum?.fc ??""}</td>
      </tr>
    </tbody>
  </table>
</div>)
}
const getCount=(c)=>{
  if(c){
    if (items.some(item => JSON.stringify(item) === JSON.stringify(c))) {
      return;
    }
    items.push(c);
  }
}

const showSectorCapacity=(px)=>{
  const {status}=px;
  let cap={};
  status?.forEach(({ class: className }) => {
    cap[className] = (cap[className] || 0) + 1;
  });
  getCount(cap);
  return(<div className="flexCol">
    <table className="sub-table">
      <thead>
        <tr>
          <th>Economy</th>
          <th>Premium Economy</th>
          <th>Business Class</th>
          <th>First Class</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{backgroundColor:" #001d2b",color:'#ffff',width:'auto'}}>{cap.ecy??""}</td>
          <td>{cap.pc??""}</td>
          <td>{cap.bc??""}</td>
          <td>{cap.fc??""}</td>
        </tr>
      </tbody>
    </table>
  </div>)
  }
export const CateringSummary = (props) => {
  const { group, timezone,status,getCorrectedTailNo} = props
  const [paxSum, SetpaxSum] = useState({});
  const [itemsPax,setItemsPax]=useState([]);

  const summForpaxTotal=()=>{
    const sumPaxxed={};
    itemsPax?.forEach((item,index)=>{
      Object.keys(item).forEach((key)=>{
        sumPaxxed[key]=(sumPaxxed[key]||0)+item[key]
      })
    })
    return sumPaxxed;
  }
  const cachSum = useMemo(() => {
    return summForpaxTotal();
  }, [itemsPax]);

useEffect(() => {
  if(cachSum){
    SetpaxSum(cachSum);
  }
}, [cachSum])

useEffect(() => {
  items=[]
}, [])

useEffect(() => {
  if(items.length){
    setItemsPax(items)
  }
}, [items])

  return (
    <div className="flexCol cntrl-calender-summary op-aircraft-container ng-grid-right flexCol full-flex ag-theme-alpine-dark">
      <span>
          <div className='table-header'></div>
          <table>
            <tbody>
            <tr >
              <td>Flight Date</td>
              <td>{moment(formatDateByTimezone(new Date(group.date))).format('YYYY-MM-DD')}</td>
            </tr>
            <tr>
              <td>STD</td>
              <td>{formatDateByTimezone(new Date(group.startTime), timezone === 'utc' ?true : false,true)}</td>
            </tr>
            <tr>
              <td>ETD</td>
              <td>{formatDateByTimezone(new Date(group.endTime), timezone === 'utc' ? true : false, true)}</td>
            </tr>
            <tr>
              <td>Tail Number</td>
              <td>{status?getCorrectedTailNo(status.tailNumber) : ''}</td>
            </tr>
            <tr>
              <td>Pax Summary</td>
              <td>
                <CountTable status={status} mode={"paxSummary"} paxSum={paxSum}/>
              </td>
            </tr>
            <tr>
            <td colSpan={2} className="spl-row-class fontExtrabold" style={{textAlign:'center'}}>Sectors</td>
            </tr>
            {
              group.sectors?.map((sector, index) => {
                return (
                  <tr key={index}>
                    <td>{SectorRenderer({data:sector})}</td>
                    <td>
                      <CountTable mode={"paxSectors"} status={status.manifests?status.manifests[index]?.passengers:null} key={index}/>
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </table>
      </span>

    </div>

  )
}